<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <button uilabMatButton="outlined" (click)="toggleBasicExample()">
            Toggle side-sheet
        </button>

        <uilab-mat-sidenav-container>
            <uilab-mat-sidenav
                mode="over"
                position="end"
                [opened]="basicExampleOpened"
            >
                <h4>Side-sheet title</h4>
                <p>
                    Use this area for contextual information and follow-up
                    actions.
                </p>
                <button uilabMatButton="text" (click)="closeBasicExample()">
                    Close
                </button>
            </uilab-mat-sidenav>

            <uilab-mat-sidenav-content>
                Main content stays visible while the side-sheet is open.
            </uilab-mat-sidenav-content>
        </uilab-mat-sidenav-container>
    </avd-code-example>
}
